// extracted by mini-css-extract-plugin
export default {"main":"CategoriesWrapper_main__+0--9","aside":"CategoriesWrapper_aside__FMX3p","article":"CategoriesWrapper_article__GJvNQ"};